module.exports = __webpack_public_path__ + "img/payout_active.376b76e8.svg";